import { render, staticRenderFns } from "./monitor_list.vue?vue&type=template&id=636f9e5a&scoped=true&"
import script from "./monitor_list.vue?vue&type=script&lang=js&"
export * from "./monitor_list.vue?vue&type=script&lang=js&"
import style0 from "./monitor_list.vue?vue&type=style&index=0&id=636f9e5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f9e5a",
  null
  
)

export default component.exports